module.exports = __webpack_public_path__ + "img/20190828162912360截图20190828160816945.6ea908f0.jpg";